export default class CurrencyDetailsItem 
{
  constructor(item) 
  {
    if (item === undefined) 
    {
      this.CurrencyId = "";
      this.Code = "";
      this.Description = "";
      this.Symbol = "";
      this.IsActive = "";
      this.ToEURRate = "";
      this.Rate = "";
      this.ToEurInverseRate = "";
      this.InverseRate = "";
      this.ThirtyDayRate = "";
      this.NinetyDayRate = "";
      this.MonthToDateRate = "";
      this.YearToDateRate = "";
      this.ThirtyDayInverseRate = "";
      this.NinetyDayInverseRate = "";
      this.MonthToDateInverseRate = "";
      this.YearToDateInverseRate = "";
    } 
    else
     {
      this.initialize(item);
    }
  }

  async initialize(item) 
  {
    this.CurrencyId = item.currencyId;
    this.Code = item.code;
    this.Description = item.description;
    this.Symbol = item.symbol;
    this.IsActive = item.isActive;
    this.ToEURRate = item.toEURRate;
    this.Rate = item.rate;
    this.ToEurInverseRate = item.toEurInverseRate;
    this.InverseRate = item.inverseRate;
    this.ThirtyDayRate = item.thirtyDayRate;
    this.NinetyDayRate = item.ninetyDayRate;
    this.MonthToDateRate = item.monthToDateRate;
    this.YearToDateRate = item.yearToDateRate;
    this.ThirtyDayInverseRate = item.thirtyDayInverseRate;
    this.NinetyDayInverseRate = item.ninetyDayInverseRate;
    this.MonthToDateInverseRate = item.monthToDateInverseRate;
    this.YearToDateInverseRate = item.yearToDateInverseRate;
  }

  static NameOfTheIdField() 
  {
    return "Code";
  }

  static nameOfTheItemDetailList() 
  {
    return "Code";
  }

  static MoneyFields = [];

  static Currency() 
  {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {return "";}

  static DateFields = [];

  static BoolFields = [];

  static clickOnDetails(item) 
  {
  }

  static FieldsToShowInDataTable()
  {
    return [];
  }
}
